/**
 * Turns a failed workshops fetch into a message that reads differently for a
 * bad request than for anything else — a validation problem and a server
 * failure are not the same thing to a teacher reading the page.
 */
const BAD_RANGE_MESSAGE =
  "That date range couldn't be read — try a smaller window or reload the page.";
const GENERIC_MESSAGE = "Workshops couldn't be loaded. Try again in a moment.";

export function regionScheduleErrorMessage(error: unknown): string {
  const message = error instanceof Error ? error.message : '';
  return message.includes('400') ? BAD_RANGE_MESSAGE : GENERIC_MESSAGE;
}
